import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import { HealthSystemDomainUsersResultUserViewModel } from '../api/HealthSystemApi';

interface IProps {
  value: string | undefined | null;
  employees: HealthSystemDomainUsersResultUserViewModel[];
  onUserSelect: (value: string) => void;
  allowNotSelected?: boolean;
  disabled?: boolean;
  cssClass?: string;
  fullWidth?: boolean;
  variant?: 'outlined' | 'filled' | 'standard';
  labelText?: string;
}

const EmployeeSelect = ({
  value,
  onUserSelect,
  allowNotSelected,
  employees,
  cssClass,
  fullWidth,
  variant,
  labelText,
  disabled
}: IProps) => {
  const { t } = useTranslation();
  const selectId = React.useId();

  const handleValueChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    //callback
    onUserSelect && onUserSelect(value);
  };

  return (
    <FormControl className={cssClass} size="small" fullWidth={fullWidth} disabled={disabled} variant={variant}>
      <InputLabel id={`${selectId}-label`}>{labelText || t('f-employee')}</InputLabel>

      <Select
        label={labelText || t('f-employee')}
        labelId={`${selectId}-label`}
        id={selectId}
        value={value ?? ''}
        onChange={handleValueChange}
      >
        {allowNotSelected && (
          <MenuItem divider value={''} id="no-employee">
            {t('f-employee-not-spec')}
          </MenuItem>
        )}

        {employees.map((employee) => (
          <MenuItem value={employee.id} key={employee.id}>
            {employee.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EmployeeSelect;
